<template>
  <div class=" flex-1 a-center h100 headMenu d-flex" >
    <div
      v-for="(item, index) in MenuList"
      :key="index"
      style="cursor:pointer;font-size:1rem;"
      class="c-000 Pointerhover h100 d-flex a-center p-x-2  "
      :class="[ $route.path.includes(item.fakePath) ? 'activeTitle' : '']"
      @click="goDetail(item.id, item.target, item.nameCn,item.fakePath)"
    >
      <span>{{ item.nameCn }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "head-nav",
  props: ["MenuList"],
  data() {
    return {
    };
  },
  mounted() {
    // console.log(this.MenuList)
    // console.log(this.$route.path)
  },
  methods: {
    goDetail(id,target,nameCn,fakePath) {
      this.$emit("goDetail", id,target,nameCn,fakePath);
    },
  },
};
</script>

<style scoped lang="less" >
.headMenu {
  .activeTitle {
    background-color: #aaa;
    color: #fff;
  }
}
.Pointerhover {
  margin-right: 10px
}
.Pointerhover:hover {
  background-color: #ccc;
}
</style>
